import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import Select from 'react-select';
import langUtils from '../../../../../utils/langUtils';
import _get from 'lodash/get';
import {Field} from 'formik';
import TextareaBox from '../../../../../components/formik/TextareaBox';
import InputBox from '../../../../../components/formik/InputBox';
import Section from '../../layout/Section';

export default function TextSettings({formikProps}) {
  const {t} = useTranslation();
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.settings">
          Text Settings
        </Trans>
      }
    >
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.select.editing.language">
            Select Editing Language
          </Trans>
        }
      >
        <Select
          options={langUtils.getAppLangList()}
          onChange={o => {
            formikProps.setFieldValue('skinResultPage.recommendation.text.textLanguage', o);
          }}
          value={_get(formikProps.values, 'skinResultPage.recommendation.text.textLanguage', {
            label: 'English',
            value: 'enu',
          })}
          isSearchable={false}
          isClearable={false}
          placeholder={
            <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
          }
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.banner.subtitle">
            Recommendation Banner Subtitle
          </Trans>
        }
      >
        <Field
          name={`skinResultPage.recommendation.text.summary.${_get(
            formikProps.values,
            'skinResultPage.recommendation.text.textLanguage.value',
            'enu'
          )}`}
          component={TextareaBox}
          placeholder={t('c.f.text.up.character', {
            defaultValue: 'Up to {{maxNum}} characters recommended.',
            maxNum: 150,
          })}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.heading">
            Product Heading
          </Trans>
        }
      >
        <Field
          name={`skinResultPage.recommendation.text.productHeading.${_get(
            formikProps.values,
            'skinResultPage.recommendation.text.textLanguage.value',
            'enu'
          )}`}
          component={InputBox}
          placeholder={t('c.f.text.up.character', {
            defaultValue: 'Up to {{maxNum}} characters recommended.',
            maxNum: 200,
          })}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.routine.heading">
            Routine Heading
          </Trans>
        }
      >
        <Field
          name={`skinResultPage.recommendation.text.routineHeading.${_get(
            formikProps.values,
            'skinResultPage.recommendation.text.textLanguage.value',
            'enu'
          )}`}
          component={InputBox}
          placeholder={t('c.f.text.up.character', {
            defaultValue: 'Up to {{maxNum}} characters recommended.',
            maxNum: 200,
          })}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.treatment.heading">
            Treatment Heading
          </Trans>
        }
      >
        <Field
          name={`skinResultPage.recommendation.text.treatmentHeading.${_get(
            formikProps.values,
            'skinResultPage.recommendation.text.textLanguage.value',
            'enu'
          )}`}
          component={InputBox}
          placeholder={t('c.f.text.up.character', {
            defaultValue: 'Up to {{maxNum}} characters recommended.',
            maxNum: 200,
          })}
        />
      </LeftTitleWithField>
    </Section>
  );
}
